var _rect, _path, _path2, _path3, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalMarket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    fill: "#FDF2ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.836 14.9996C29.6488 14.7002 29.3808 14.4507 29.058 14.2755C28.7352 14.1002 28.3688 14.0052 27.9943 13.9996H14.1277L13.4993 11.7396C13.4359 11.5214 13.2942 11.3296 13.0975 11.1952C12.9008 11.0608 12.6606 10.9919 12.416 10.9996H10.2493C9.96203 10.9996 9.68648 11.105 9.48332 11.2925C9.28015 11.48 9.16602 11.7344 9.16602 11.9996C9.16602 12.2648 9.28015 12.5192 9.48332 12.7067C9.68648 12.8943 9.96203 12.9996 10.2493 12.9996H11.5927L14.5827 23.2596C14.6462 23.4778 14.7878 23.6697 14.9845 23.804C15.1812 23.9384 15.4214 24.0073 15.666 23.9996H25.416C25.6161 23.9991 25.8121 23.9474 25.9822 23.8503C26.1524 23.7532 26.2902 23.6145 26.3802 23.4496L29.9335 16.8896C30.0875 16.5916 30.1592 16.2631 30.1422 15.9333C30.1252 15.6035 30.02 15.2827 29.836 14.9996ZM24.7443 21.9996H16.4893L14.7235 15.9996H27.9943L24.7443 21.9996Z",
    fill: "#E87A46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 29C16.0225 29 16.75 28.3284 16.75 27.5C16.75 26.6716 16.0225 26 15.125 26C14.2275 26 13.5 26.6716 13.5 27.5C13.5 28.3284 14.2275 29 15.125 29Z",
    fill: "#E87A46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.959 29C26.8564 29 27.584 28.3284 27.584 27.5C27.584 26.6716 26.8564 26 25.959 26C25.0615 26 24.334 26.6716 24.334 27.5C24.334 28.3284 25.0615 29 25.959 29Z",
    fill: "#E87A46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 38.5,
    height: 38.5,
    rx: 19.25,
    stroke: "#E87A46",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalMarket);
export default __webpack_public_path__ + "static/media/TotalMarket.079d1c3693e0bf1e5a0b6cd7e11d0bd1.svg";
export { ForwardRef as ReactComponent };